import { isEmojiSupported } from "is-emoji-supported";
import { ColorAA } from "../../../components/src/constants";
import { useMemo } from "react";
import { CommonAgentSummary } from "../types";

const AgentIcon = ({
  agent,
  className,
}: {
  agent?: CommonAgentSummary | null;
  className?: string;
}) => {
  const emoji = agent?.emoji;

  const emojiIsSupported = useMemo(() => {
    return emoji && isEmojiSupported(emoji);
  }, [emoji]);

  return emojiIsSupported ? (
    <span className={className} style={{ userSelect: "none" }}>
      {emoji}
    </span>
  ) : (
    <span className={className} style={{ color: ColorAA.grey }}>
      <i className="bi-person-circle" />
    </span>
  );
};

export default AgentIcon;
